import { render, staticRenderFns } from "./PainelPecas.vue?vue&type=template&id=eb9ad572&"
import script from "./PainelPecas.vue?vue&type=script&lang=js&"
export * from "./PainelPecas.vue?vue&type=script&lang=js&"
import style0 from "./PainelPecas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports